export const events = {
    open: "open",
    gameCardClick: "gameCardClick",
    gamePlayClick: "gamePlayClick",
}
export const screen = {
    homePage: "homePage",
    gamePage : "gamePage",
    unsubPage:"unsubPage",
    categoryPage:"categoryPage"
}


